import { ROLES } from '@/shared/constants/roles';

export const canUnblockCard = (
    currentUserUuid: string | undefined,
    currentUserRole: string | undefined,
    blockerUuid: string | undefined | null,
    blockerRole: string | undefined | null,
    accountOwnerUuid: string | undefined,
    accountOwnerRole: string | undefined
): boolean => {
    if (!blockerUuid) {
        return currentUserUuid === accountOwnerUuid;
    }

    if (blockerUuid === currentUserUuid) {
        return true;
    }

    const currentRole = (currentUserRole || ROLES.BASIC).toUpperCase();
    const bRole = (blockerRole || ROLES.BASIC).toUpperCase();
    const ownerRole = (accountOwnerRole || ROLES.BASIC).toUpperCase();

    if (currentRole === ROLES.OWNER) {
        return true;
    }

    if (currentRole === ROLES.ADMIN) {
        if (ownerRole === ROLES.ADMIN) {
            return false;
        }

        if (bRole === ROLES.OWNER) {
            return false;
        }

        if (ownerRole === ROLES.BASIC) {
            return true;
        }
    }

    if (currentRole === ROLES.BASIC) {
        return false;
    }

    return false;
};
